
/** sticky category navigation desktop + mobile */
document.addEventListener("DOMContentLoaded", function () {

function isViewportPastElementID(elementId) {
  // Get the element by ID
  let element = document.getElementById(elementId);

  if (!element) {
    console.warn(`Element with ID ${elementId} not found.`);
    return false;
  }

  // Get the bounding rectangle of the element
  let rect = element.getBoundingClientRect();

  // Check if the element is past the viewport
  return (
    rect.top < window.innerHeight && rect.bottom > 500
  );
}



  if (document.body.classList.contains("template-page")&&
  document.body.id !== "uber-uns" &&
  document.body.id !== "alle-produkte" &&
    document.body.id !== "dein-30-sekunden-hautpflege-check" &&
    document.body.id !== "adv-tallow-natur" &&
    document.body.id !== "adv-tallow-honig" &&
    document.body.id !== "adv-tallow-lavendel" &&
    document.body.id !== "ihre-schlafgarantie-5-revolutionare-schritte-und-eine-routine-die-ti" &&
  document.body.id !== "haufige-fragen") {
    const wordLimit = 20;
    const mainContentDiv = document.querySelector(".main-content");
    const resultDiv = document.createElement("div");
    resultDiv.classList.add("sticky-page-navigation");
    const ul = document.createElement("ul");
    const li = document.createElement("li");
    li.innerHTML = "<strong>DIREKT ZU</strong>";
    ul.appendChild(li);
    resultDiv.appendChild(ul);

    // Get all headers with a class of "section-header"
    const headers = document.querySelectorAll(".article-body h1,h2,h3,h4,h5,h6");
    const header2 = document.querySelectorAll(".article-body h2");
    if (headers.length > 0) {
      mainContentDiv.prepend(resultDiv);
    }
    headers.forEach((element, index) => {
      const li = document.createElement("li");
      let words = element.textContent.split(" ");
      let truncatedText;
      if (words.length > wordLimit) {
        truncatedText = words.slice(0, wordLimit).join(" ") + "...";
      } else {
        truncatedText = element.textContent;
      }
      li.innerHTML = `<a href="#header-${index}">${truncatedText}</a>`;
      ul.appendChild(li);
      element.id = `header-${index}`;
    });
  }

  // category nav for products and collections

  let catNav = document.getElementById("category-nav-wrapper");
  if (catNav) {
    const windowScrollY = window.scrollY;
    const stickyPosition = catNav.offsetTop;
    window.addEventListener("scroll", function () {
      if (window.scrollY >= stickyPosition) {
        catNav.classList.add("sticky");
      } else {
        catNav.classList.remove("sticky");
      }
    });
  }

  // sticky category nav mobile
  let catNavMobile = document.getElementById("category-nav-mobile");
  if (catNavMobile) {
    const windowScrollY = window.scrollY;
    const stickyPosition = catNavMobile.offsetTop;
    window.addEventListener("scroll", function () {
      if (window.scrollY >= stickyPosition) {
        catNavMobile.classList.add("sticky");
      } else {
        catNavMobile.classList.remove("sticky");
      }
    });
  }

  // Collection page scroll up button
  let scrollUpButton = document.getElementById("scroll-up-button");
  if (scrollUpButton) {
    window.addEventListener("scroll", function () {
      if (window.scrollY > 500) {
        scrollUpButton.style.display = "block";
      } else {
        scrollUpButton.style.display = "none";
      }
    });
  }

  // Collection page open/close sidebar
  let openSidebar = document.getElementById("open-sidebar");
  let closeSidebar = document.getElementById("close-sidebar");
  let sidebar = document.getElementById("mobile-sidebar");
  if (openSidebar && closeSidebar && sidebar) {
    openSidebar.addEventListener("click", function () {
      sidebar.classList.add("open");
      document.body.classList.add("overflow-hidden");
    });
    closeSidebar.addEventListener("click", function () {
      sidebar.classList.remove("open");
      document.body.classList.remove("overflow-hidden");
    });
  }


  let swatchWrapper = document.querySelectorAll(".product-card__swatch-wrapper");
  swatchWrapper.forEach(function (element) {
    let swatchElements = element.querySelectorAll(".product-card__swatch");
    if (swatchElements.length > 5) {
      let extraSwatches = Array.from(swatchElements).slice(5);
      let extraCount = extraSwatches.length;
      extraSwatches.forEach(function (swatch) {
        swatch.style.display = "none";
      });
      let moreButton = document.createElement("span");
      moreButton.className = "more-swatches";
      moreButton.textContent = `+${extraCount}`;
      element.appendChild(moreButton);
    }
  });


  // checkbox filters on collection page

  const checkboxes = document.querySelectorAll(".filter-checkbox");
  const allCheckboxes = document.querySelectorAll(".filter-checkbox");
  const products = document.querySelectorAll(".product-card");
  const resetButton = document.getElementById("reset-filter");
  if (checkboxes.length > 0) {
    checkboxes.forEach(function (checkbox) {
      checkbox.addEventListener("change", function () {
        const checkedValues = [];
        allCheckboxes.forEach(function (cb) {
          if (cb.checked) {
            checkedValues.push(cb.value);
          }
        });
        products.forEach(function (product) {
          if (checkedValues.length === 0) {
            product.style.display = "block";
          } else {
            const productTags = product.dataset.tags;
            const isMatch = checkedValues.some(function (value) {
              return productTags.includes(value);
            });
            product.style.display = isMatch ? "block" : "none";
          }
        });
      });
    });
    if (resetButton) {
      resetButton.addEventListener("click", function () {
        allCheckboxes.forEach(function (cb) {
          cb.checked = false;
        });
        products.forEach(function (product) {
          product.style.display = "block";
        });
      });
    }
  }

  // let mobileMenuItems = document.getElementsByClassName("menu-item-mobile");
  // for (let i = 0; i < mobileMenuItems.length; i++) {
  //   mobileMenuItems[i].addEventListener("click", function () {
  //     let subMenu = this.querySelector(".sub-menu-mobile");
  //     if (subMenu) {
  //       subMenu.classList.toggle("open");
  //     }
  //   });
  // }

  // Read More / Read Less button
  let readMoreButtons = document.querySelectorAll(".read-more-btn");
  readMoreButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      const text = this.previousElementSibling;
      if (text) {
        text.classList.toggle("expanded");
        if (text.classList.contains("expanded")) {
          this.textContent = "Weniger lesen";
        } else {
          this.textContent = "Mehr lesen";
        }
      }
    });
  });


  // Video playback
  let videos = document.querySelectorAll("video");
  videos.forEach(function (video) {
    video.play();
  });

  let videoThumbnail = document.querySelectorAll(".video-thumbnail");
  videoThumbnail.forEach(function (video) {
    video.addEventListener("click", function () {
      let iframe = this.querySelector(".video-iframe");
      if (iframe) {
        iframe.style.display = "block";
        this.querySelector(".video-thumbnail-image").style.display = "none";
      }
    });
  });


  // Product slider by tags
  const tabs = document.querySelectorAll(".product-tab-tab");
  const tabContents = document.querySelectorAll(".tab-content");
  if (tabs.length > 0) {
    function setActiveTab(index) {
      tabs.forEach((tab, i) => {
        if (i === index) {
          tab.classList.add("active");
        } else {
          tab.classList.remove("active");
        }
      });
      tabContents.forEach((content, i) => {
        if (i === index) {
          content.classList.add("active");
        } else {
          content.classList.remove("active");
        }
      });
    }
    setActiveTab(0);
    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => setActiveTab(index));
    });
  }


  // mini cart logic

  let cart = document.getElementById("cart-drawer");
  let closeCart = document.getElementById("close-cart");
  let openCart = document.getElementById("cart-icon-button");
  if (cart && closeCart && openCart) {
    openCart.addEventListener("click", function () {
      cart.classList.add("open");
      document.body.classList.add("overflow-hidden");
    });
    closeCart.addEventListener("click", function () {
      cart.classList.remove("open");
      document.body.classList.remove("overflow-hidden");
    });
  }

  let cartOverlay = document.getElementById("cart-overlay");
  if (cartOverlay) {
    cartOverlay.addEventListener("click", function () {
      cart.classList.remove("open");
      document.body.classList.remove("overflow-hidden");
    });
  }

  // quantity selector in mini cart
  let incrementButtons = document.querySelectorAll(".increment-btn");
  let decrementButtons = document.querySelectorAll(".decrement-btn");
  incrementButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      let quantityInput = this.parentElement.querySelector(".quantity-input");
      let quantity = parseInt(quantityInput.value);
      quantityInput.value = quantity + 1;
    });
  });
  decrementButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      let quantityInput = this.parentElement.querySelector(".quantity-input");
      let quantity = parseInt(quantityInput.value);
      if (quantity > 1) {
        quantityInput.value = quantity - 1;
      }
    });
  });

  // quantity selector on product page
  let incrementBtn = document.getElementById("increment-btn");
  let decrementBtn = document.getElementById("decrement-btn");
  let quantityInput = document.getElementById("quantity-input");
  if (incrementBtn && decrementBtn && quantityInput) {
    incrementBtn.addEventListener("click", function () {
      let quantity = parseInt(quantityInput.value);
      quantityInput.value = quantity + 1;
    });
    decrementBtn.addEventListener("click", function () {
      let quantity = parseInt(quantityInput.value);
      if (quantity > 1) {
        quantityInput.value = quantity - 1;
      }
    });
  }


  // open search bar
  let openSearch = document.getElementById("open-search");
  let searchBar = document.getElementById("search-bar");
  let searchClose = document.getElementById("search-close");
  if (openSearch && searchBar && searchClose) {
    openSearch.addEventListener("click", function () {
      searchBar.classList.add("open");
      document.body.classList.add("overflow-hidden");
    });
    searchClose.addEventListener("click", function () {
      searchBar.classList.remove("open");
      document.body.classList.remove("overflow-hidden");
    });
  }


  let accordionHeaders = document.querySelectorAll(".accordion-header");
  accordionHeaders.forEach(function (header) {
    header.addEventListener("click", function () {
      let content = this.nextElementSibling;
      if (content) {
        content.classList.toggle("open");
      }
      this.classList.toggle("open");
    });
  });


  let faqAccordionHeaders = document.querySelectorAll(".faq-accordion-header");
  faqAccordionHeaders.forEach(function (header) {
    header.addEventListener("click", function () {
      let content = this.nextElementSibling;
      if (content) {
        content.classList.toggle("open");
      }
      this.classList.toggle("open");
    });
  });


  let navToggle = document.getElementById("nav-toggle");
  let navMobile = document.getElementById("nav-mobile");
  if (navToggle && navMobile) {
    navToggle.addEventListener("click", function () {
      navMobile.classList.toggle("open");
      document.body.classList.toggle("overflow-hidden");
    });
  }

  let navMobileOverlay = document.getElementById("nav-mobile-overlay");
  if (navMobileOverlay) {
    navMobileOverlay.addEventListener("click", function () {
      navMobile.classList.remove("open");
      document.body.classList.remove("overflow-hidden");
    });
  }


  // mobile nav submenu
  let mobileNavItems = document.querySelectorAll(".mobile-nav-item");
  mobileNavItems.forEach(function (item) {
    item.addEventListener("click", function () {
      let subMenu = item.querySelector(".mobile-nav-submenu");
      if (subMenu) {
        subMenu.classList.toggle("open");
        item.classList.toggle("open");
      }
    });
  });


  // product gallery
  let productImages = document.querySelectorAll(".product-gallery__image");
  let mainImage = document.getElementById("main-image");
  if (mainImage && productImages.length > 0) {
    productImages.forEach(function (image) {
      image.addEventListener("click", function () {
        let imageSrc = this.src;
        mainImage.src = imageSrc;
        productImages.forEach(function (img) {
          img.classList.remove("active");
        });
        this.classList.add("active");
      });
    });
  }


  // star rating
  let stars = document.querySelectorAll(".star-rating span");
  stars.forEach(function (star) {
    star.addEventListener("click", function () {
      let rating = this.dataset.rating;
      stars.forEach(function (s) {
        if (s.dataset.rating <= rating) {
          s.classList.add("active");
        } else {
          s.classList.remove("active");
        }
      });
    });
  });


  // Newsletter popup
  let newsletterPopup = document.getElementById("newsletter-popup");
  let newsletterPopupClose = document.getElementById("newsletter-popup-close");
  let newsletterPopupOverlay = document.getElementById("newsletter-popup-overlay");
  if (newsletterPopup) {
    setTimeout(function () {
      if (!localStorage.getItem("newsletterPopupShown")) {
        newsletterPopup.classList.add("active");
      }
    }, 5000);
    if (newsletterPopupClose) {
      newsletterPopupClose.addEventListener("click", function () {
        newsletterPopup.classList.remove("active");
        localStorage.setItem("newsletterPopupShown", true);
      });
    }
    if (newsletterPopupOverlay) {
      newsletterPopupOverlay.addEventListener("click", function () {
        newsletterPopup.classList.remove("active");
        localStorage.setItem("newsletterPopupShown", true);
      });
    }
  }


  let addToCartButtons = document.querySelectorAll(".add-to-cart-btn");
  addToCartButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      let variantId = this.dataset.variantId;
      let quantity = document.getElementById("quantity-input")
        ? parseInt(document.getElementById("quantity-input").value)
        : 1;
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: quantity,
            },
          ],
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          fetch("/cart.js")
            .then((response) => response.json())
            .then((cartData) => {
              console.log(cartData);
              let cartCount = document.querySelectorAll(
                ".cart-count"
              );
              cartCount.forEach(function (el) {
                el.textContent = cartData.item_count;
              });
              let cartItems = document.getElementById("cart-items");
              if (cartItems) {
                cartItems.innerHTML = "";
                cartData.items.forEach(function (item) {
                  let cartItem = document.createElement("div");
                  cartItem.className = "cart-item";
                  cartItem.innerHTML = `
                  <img src="${item.image}" alt="${item.title}">
                  <div class="cart-item-info">
                  <p class="cart-item-title">${item.title}</p>
                  <p class="cart-item-price">${item.price / 100}</p>
                  </div>
                  `;
                  cartItems.appendChild(cartItem);
                });
              }
              let cartTotal = document.getElementById("cart-total");
              if (cartTotal) {
                cartTotal.innerHTML = `Total: ${cartData.total_price / 100} € `;
              }
              let cartDrawer = document.getElementById("cart-drawer");
              if (cartDrawer) {
                cartDrawer.classList.add("open");
                document.body.classList.add("overflow-hidden");
              }
            });
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
  });

  // // update cart quantity
  // let quantityInputs = document.querySelectorAll(".quantity-input");
  // quantityInputs.forEach(function (input) {
  //   input.addEventListener("change", function () {
  //     let lineItemIndex = this.dataset.lineItemIndex;
  //     let quantity = int(this.value);
  //     fetch("/cart/change.js", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ line: lineItemIndex, quantity: quantity }),
  //     })
  //       .then((response) => response.json())
  //       .then((data) => {
  //         console.log(data);
  //       });
  //   });
  // });


});